/* =========================================================
   Gud Mishri – Diwali Theme Pack  (assets/gm-diwali.js)
   Crackers on Add-to-Cart, petals, sparkle cursor,
   diya on headings, Diwali countdown.
   ========================================================= */
(function () {
  'use strict';
  var root = document.getElementById('gm-diwali');
  if (!root || root.dataset.gmInit) return;
  root.dataset.gmInit = '1';

  var cfg = root.dataset;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var allowMobile = cfg.mobile === 'true';
  var fxAllowed = !reduceMotion && (!isMobile || allowMobile);

  /* Kandil Position */
  var portal = document.createElement('div');
  portal.id = 'gm-diwali-portal';
  function syncPortal(r) {
    portal.className = r.className;
    portal.setAttribute('style', r.getAttribute('style') || '');
  }
  function movePortalItems(r) {
    portal.querySelectorAll('.gm-lantern').forEach(function (el) { el.remove(); });
    var first = portal.firstChild;
    r.querySelectorAll('.gm-lantern').forEach(function (el) { portal.insertBefore(el, first); });
    r.querySelectorAll('.gm-fx-canvas, .gm-toast').forEach(function (el) {
      if (!portal.querySelector('.' + el.className.split(' ')[0])) portal.appendChild(el); else el.remove();
    });
  }
  function forceLayer() {
    // Override Theme (above on sticky header)
    var z = getComputedStyle(portal).getPropertyValue('--gm-lantern-z').trim() || '2147482990';
    portal.querySelectorAll('.gm-lantern').forEach(function (el) {
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('z-index', z, 'important');
    });
  }
  syncPortal(root);
  movePortalItems(root);
  document.body.appendChild(portal);
  forceLayer();
  console.log('%c🪔 GM Diwali v3 loaded', 'color:#e65100;font-weight:bold');

  // Change Theme editor: section setting
  document.addEventListener('shopify:section:load', function () {
    var r = document.getElementById('gm-diwali');
    if (!r) return;
    root = r; syncPortal(r); movePortalItems(r);
    document.body.appendChild(portal); // always last rahe
    forceLayer();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#gm-diwali')) {
      portal.querySelectorAll('.gm-lantern').forEach(function (el) { el.remove(); });
    }
  });

  /* ---------------- 1. Crackers (canvas firework burst) ---------------- */
  var canvas = portal.querySelector('.gm-fx-canvas');
  var ctx = canvas && canvas.getContext('2d');
  var particles = [];
  var running = false;
  var COLORS = ['#ffd54f', '#ffb300', '#ff7043', '#e53935', '#ec407a', '#ab47bc', '#66bb6a', '#fff8e1'];

  function sizeCanvas() {
    if (!canvas) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = innerWidth * dpr;
    canvas.height = innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', sizeCanvas, { passive: true });
  sizeCanvas();

  function burst(x, y, count) {
    count = count || (isMobile ? 70 : 120);
    for (var i = 0; i < count; i++) {
      var ang = Math.random() * Math.PI * 2;
      var spd = 2 + Math.random() * (isMobile ? 5 : 7);
      particles.push({
        x: x, y: y,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd - 1.5,
        life: 1,
        decay: 0.012 + Math.random() * 0.018,
        size: 1.5 + Math.random() * 2.5,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        trail: Math.random() < 0.35
      });
    }
    if (!running) { running = true; requestAnimationFrame(tick); }
  }

  function tick() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    ctx.globalCompositeOperation = 'lighter';
    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.vx *= 0.985; p.vy = p.vy * 0.985 + 0.09;
      p.x += p.vx; p.y += p.vy; p.life -= p.decay;
      if (p.life <= 0) { particles.splice(i, 1); continue; }
      ctx.globalAlpha = Math.max(p.life, 0);
      ctx.fillStyle = p.color;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2); ctx.fill();
      if (p.trail) {
        ctx.globalAlpha = p.life * 0.4;
        ctx.beginPath(); ctx.arc(p.x - p.vx * 2, p.y - p.vy * 2, p.size * 0.6, 0, Math.PI * 2); ctx.fill();
      }
    }
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';
    if (particles.length) requestAnimationFrame(tick);
    else { running = false; ctx.clearRect(0, 0, innerWidth, innerHeight); }
  }

  /* Anar + rocket style celebration */
  function celebrate(x, y) {
    if (!fxAllowed || !ctx) return;
    x = x == null ? innerWidth / 2 : x;
    y = y == null ? innerHeight / 2 : y;
    burst(x, y);
    setTimeout(function () { burst(innerWidth * (0.2 + Math.random() * 0.2), innerHeight * 0.3, 70); }, 220);
    setTimeout(function () { burst(innerWidth * (0.6 + Math.random() * 0.2), innerHeight * 0.25, 70); }, 420);
  }

  var toastEl = portal.querySelector('.gm-toast');
  var toastTimer;
  function toast() {
    if (!toastEl || !cfg.toast) return;
    toastEl.textContent = cfg.toast;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
  }

  var ATC_SELECTOR = [
    'button[name="add"]', '[data-add-to-cart]', '.add-to-cart', '.btn--add-to-cart',
    'form[action*="/cart/add"] [type="submit"]', '.quick-add-btn', '[data-quick-add]'
  ].join(',');

  var lastClick = { x: null, y: null, t: 0 };
  var lastFire = 0;

  function fire() {
    var now = Date.now();
    if (now - lastFire < 900) return; // double event se bachao
    lastFire = now;
    var fresh = now - lastClick.t < 6000;
    celebrate(fresh ? lastClick.x : null, fresh ? lastClick.y : null);
    toast();
  }

  if (cfg.crackers === 'true') {
    // Click position yaad rakho (burst wahin se niklega)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(ATC_SELECTOR);
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      lastClick = { x: r.left + r.width / 2, y: r.top + r.height / 2, t: Date.now() };
    }, true);

    // Impulse theme ka apna success event
    document.addEventListener('ajaxProduct:added', fire);
    document.addEventListener('cart:item-added', fire);

    // Universal: /cart/add ka successful fetch pakdo (quick-add, upsell, etc.)
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = _fetch.apply(this, arguments);
        if (/\/cart\/add/.test(url)) {
          p.then(function (res) { if (res && res.ok) fire(); }).catch(function () {});
        }
        return p;
      };
    }

    // Non-AJAX form submit (page redirect) – turant chhota burst
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!(f && f.action && /\/cart\/add/.test(f.action))) return;
      // Agar theme ne AJAX se handle kiya (preventDefault) to ajax event hi fire karega
      setTimeout(function () { if (!e.defaultPrevented) fire(); }, 0);
    }, true);

    // ATC buttons par halka glow
    function glowButtons() {
      document.querySelectorAll('button[name="add"]:not(.gm-atc-glow)').forEach(function (b) {
        if (!b.disabled) b.classList.add('gm-atc-glow');
      });
    }
    glowButtons();
    document.addEventListener('shopify:section:load', glowButtons);
  }

  /* ---------------- 2. Diya with section headings ---------------- */
  var tpl = document.getElementById('gm-diya-tpl');
  function addTitleDiyas(scope) {
    if (cfg.diyaTitles !== 'true' || !tpl || !cfg.titleSelector) return;
    var nodes;
    try { nodes = (scope || document).querySelectorAll(cfg.titleSelector); } catch (e) { return; }
    nodes.forEach(function (h) {
      if (h.dataset.gmDiya || h.closest('.gm-diya-strip, .gm-diwali')) return;
      h.dataset.gmDiya = '1';
      h.classList.add('gm-title-diya');
      h.insertBefore(tpl.content.cloneNode(true), h.firstChild);
      h.appendChild(tpl.content.cloneNode(true));
    });
  }
  addTitleDiyas();
  document.addEventListener('shopify:section:load', function (e) { addTitleDiyas(e.target); });

  /* ---------------- 3. Falling marigold petals ---------------- */
  var petals = parseInt(cfg.petals, 10) || 0;
  if (fxAllowed && petals > 0) {
    if (isMobile) petals = Math.ceil(petals / 2);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < petals; i++) {
      var pe = document.createElement('span');
      pe.className = 'gm-petal';
      pe.setAttribute('aria-hidden', 'true');
      pe.style.left = (Math.random() * 100) + 'vw';
      pe.style.animationDuration = (9 + Math.random() * 10) + 's';
      pe.style.animationDelay = (-Math.random() * 18) + 's';
      var sc = 0.6 + Math.random() * 0.8;
      pe.style.width = (14 * sc) + 'px';
      pe.style.height = (10 * sc) + 'px';
      frag.appendChild(pe);
    }
    portal.appendChild(frag);
  }

  /* ---------------- 4. Phuljhadi sparkle cursor (desktop only) ---------------- */
  if (fxAllowed && cfg.sparkle === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var lastSpark = 0;
    document.addEventListener('mousemove', function (e) {
      var now = performance.now();
      if (now - lastSpark < 45) return;
      lastSpark = now;
      var s = document.createElement('span');
      s.className = 'gm-spark';
      s.style.left = e.clientX + 'px';
      s.style.top = e.clientY + 'px';
      s.style.setProperty('--dx', (Math.random() * 30 - 15) + 'px');
      s.style.setProperty('--dy', (Math.random() * 24 + 6) + 'px');
      s.style.background = COLORS[(Math.random() * 3) | 0];
      portal.appendChild(s);
      setTimeout(function () { s.remove(); }, 750);
    }, { passive: true });
  }

  /* ---------------- 5. Diwali countdown ---------------- */
  var cd = root.querySelector('[data-gm-countdown]');
  if (cd && cfg.countdown) {
    var target = new Date(cfg.countdown).getTime();
    if (!isNaN(target)) {
      var upd = function () {
        var diff = target - Date.now();
        if (diff <= 0) { cd.textContent = '🪔 Shubh Deepavali!'; cd.hidden = false; return true; }
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60;
        cd.textContent = 'Diwali mein ' + d + ' din ' + h + ' ghante ' + m + ' min';
        cd.hidden = false;
      };
      if (!upd()) setInterval(upd, 30000);
    }
  }

  // Theme editor me test karne ke liye: console me GMDiwali.celebrate()
  window.GMDiwali = { celebrate: celebrate, burst: burst };
})();
